export function friendlyError(error,fallback='Wystąpił błąd. Spróbuj ponownie.'){
  const candidate=String(error?.userMessage||fallback).replace(/[\u0000-\u001f\u007f]/g,' ').trim();
  return candidate.slice(0,180)||fallback;
}

export function installGlobalErrorHandlers(target,diagnostics){
  if(!target?.addEventListener||!diagnostics?.capture)return ()=>{};
  const onError=event=>diagnostics.capture('window.error',event?.error||event?.message||'Unknown error',{filename:event?.filename?.split('/').at(-1)||'',line:event?.lineno||0});
  const onRejection=event=>diagnostics.capture('window.unhandledrejection',event?.reason||'Unhandled rejection');
  target.addEventListener('error',onError);
  target.addEventListener('unhandledrejection',onRejection);
  return ()=>{
    target.removeEventListener?.('error',onError);
    target.removeEventListener?.('unhandledrejection',onRejection);
  };
}
